import { render } from "./OurClients.vue?vue&type=template&id=75a2144f&scoped=true&ts=true"
import script from "./OurClients.vue?vue&type=script&lang=ts"
export * from "./OurClients.vue?vue&type=script&lang=ts"

import "./OurClients.vue?vue&type=style&index=0&id=75a2144f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a2144f"]])

export default __exports__